import { AfterViewInit, Directive, ElementRef, Injector, Input, NgZone, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CommonUtils, OverLayHiddenService } from '@farris/ui-common';
import { DataTableComponent } from '@farris/ui-datatable';
import { NotifyService } from '@farris/ui-notify';

@Directive({ selector: '[lookup-selected]' })
export class LookupSelectedDirective implements OnInit, AfterViewInit, OnDestroy{

    @Input() selectedPanel: ElementRef;
    @Input() dataTableRef: DataTableComponent;
    @Input() count = 0;

    private overlaySer: OverLayHiddenService;
    private panelMouseEvent = null;
    private notifySer: NotifyService = null;
    private commonUtils = null;
    private panelEscHandler = null;

    constructor(private injector: Injector, private elRef: ElementRef, private render: Renderer2, private ngZone: NgZone) {
        this.overlaySer = new OverLayHiddenService();
        this.notifySer = this.injector.get(NotifyService, null);
        this.commonUtils = this.injector.get(CommonUtils, new CommonUtils())
    }

    ngOnInit(): void {
        
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.bindingEvents();
        });

        this.panelMouseEvent =  this.overlaySer.registerMouseEvent(this.elRef.nativeElement, (e: any) => {
            if (this.selectedPanel.nativeElement.contains(e.target)  || this.elRef.nativeElement.contains(e.target) || 
            e.target.classList.contains('lookup-clear-selected-items') || e.target.closest('.farris-messager')) {
                return;
            }

            this.showPanel(false);
        });
    }

    ngOnDestroy(): void {
        if (this.panelMouseEvent) {
            this.panelMouseEvent();
            this.panelMouseEvent = null;
        }
    }

    private showPanel(show = true) {
        const panel = this.selectedPanel.nativeElement;
        if (!show) {
            this.render.removeClass(panel, 'show');
            this.render.addClass(panel, 'd-none');
            if (this.panelEscHandler) {
                this.panelEscHandler();
                this.panelEscHandler = null;
            }

        } else {
            this.render.addClass(panel, 'show');
            this.render.removeClass(panel, 'd-none');
            // æ³¨åESC
            if (this.commonUtils) {
                this.panelEscHandler = this.commonUtils.regBodyKeydownEvent(null, () => this.showPanel(false));
            }
        }
    }

    private bindingEvents() {
        if (!this.selectedPanel) {
            return;
        }
        this.ngZone.runOutsideAngular(() => {
            const panel = this.selectedPanel.nativeElement;
            
            this.render.listen(this.elRef.nativeElement, 'click', () => {
                if (this.selectedPanel && this.count) {
                    if (panel.classList.contains('show')) {
                        this.showPanel(false);
                    } else {
                        this.showPanel();
                        const selectedTableContainer = panel.querySelector('.farris-datatable-container');
                        const selectedTableBody = panel.querySelector('.farris-table-scorllable-body');
                        this.render.removeStyle(selectedTableContainer, 'height');
                        this.render.removeStyle(selectedTableBody, 'height');
                      
                        this.dataTableRef.resize({height: panel.offsetHeight - 28, width: panel.offsetWidth - 28});

                        this.render.setStyle(selectedTableBody, 'height', this.dataTableRef.tableHeight + 'px');
                        this.render.setStyle(selectedTableBody, 'height', this.dataTableRef.scorllableBodyHeight + 'px');
                        
                        this.dataTableRef.dtBody.checkBodyHeightWhenEmptyData();
                    }
                } else {
                    if (this.notifySer) {
                        this.notifySer.warning('å½åè¿æ²¡æéæ©æ°æ®ã');
                    }
                }
            });
        });
    }


}